'use es6';

import { useCallback } from 'react';
import usePromiseEffect from '../shared/hooks/usePromiseEffect';
import { useReportForMeta } from './internal/useMeta';
import { resolveDeps } from 'reporting-snowflake/relational/metadata/report-deps';

/**
 * @param reportDefinition
 */
export const useDeps = reportDefinition => {
  const reportForMeta = useReportForMeta(reportDefinition);
  const promise = useCallback(() => {
    return resolveDeps(reportForMeta);
  }, [reportForMeta]);
  return usePromiseEffect(promise);
};